import {
	Datagrid,
	DateField,
	List,
	TextField,
	TopToolbar,
	CreateButton,
	EditButton,
	FunctionField,
	TextInput

} from 'react-admin';

import { RoleChoices } from 'skylar/Roles';

const ListActions = () => (
	<TopToolbar>
		<CreateButton />
	</TopToolbar>
);

const filters = [
	<TextInput label="Search" source="q" alwaysOn />
];

const roleNames = record => {
	
	const { role } = record || [];
	return role.map( r => RoleChoices.find( d => (d.id === r) ).name ).join( ', ' );
}

export const UserList = (props) => (
	<List {...props} empty={false} actions={<ListActions />} exporter={false} filters={filters}>
		<Datagrid rowClick="edit">
			<TextField source="email" />
			<TextField source="name" />
			<TextField source="position" />
			<DateField source="last_login" showTime />
			<FunctionField source="role" render={roleNames} />
			<EditButton />
		</Datagrid>
	</List>
);

export default UserList;